module.exports = __webpack_public_path__ + "img/2500-1_YR_2022_Tailgating.c0579e38.png";